import { useState } from "react";

import classes from "./Cart.module.css";

import Modal from "../../UI/Modal";
import CartDrinks from "./CartDrinks/CartDrinks";
import CartIngredients from "./CartIngredients/CartIngredients";
import CartActions from "./CartActions/CartActions";
import MainHeader from "../General_Elements/MainHeader/MainHeader";
import SubHeader from "../General_Elements/SubHeader/SubHeader";
import CreateBookForm from "./CreateBookForm/CreateBookForm";

// component for Cart containing all drinks the User wishes to include in book
const Cart = (props) => {
  // toggle form to create book
  const [showForm, setShowForm] = useState(false);

  const showFormHandler = () => {
    setShowForm(!showForm);
  };

  return (
    <Modal onClose={props.onClose}>
      {!showForm ? (
        <div className={classes.cart}>
          <div className={classes.header}>
            <MainHeader title="Cart" />
          </div>
          <div className={classes.body}>
            <SubHeader title="Cocktails" />
            <CartDrinks />
            <SubHeader title="Ingredients" />
            <CartIngredients />
          </div>
          <div className={classes.footer}>
            <CartActions
              toggleShowForm={showFormHandler}
              onClose={props.onClose}
            />
          </div>
        </div>
      ) : (
        <CreateBookForm closeForm={showFormHandler} />
      )}
    </Modal>
  );
};

export default Cart;
